import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { ConfigurationAcceleratorsService } from '../configuration-accelerators.service';
import { ConfigurationAcceleratorsAcceleratorsViewPart } from './accelerators/accelerators-view.part';
import { ConfigurationProgramFacilitatorsViewPart } from './program-facilitators/program-facilitators-view.part';
@Component({
	selector: 'configuration-accelerators-views-part',
	standalone: true,
	imports: [
		ConfigurationAcceleratorsAcceleratorsViewPart,
		ConfigurationProgramFacilitatorsViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './accelerators-views.part.html',
})
export class ConfigurationAcceleratorsViewsPart implements OnInit {

	public service = inject(ConfigurationAcceleratorsService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}